import React, { useEffect, Fragment, useRef } from 'react';
import Zzim from '../../../zzim/Zzim';

/**
 * 상품 찜하기 컴포넌트
 */
function DealLike() {
  const mainDealSrl = `main_deal_srl:${TMON.htStaticData.sDealNo}`;
  const dealDimension = mainDealSrl;
  const dealRef = useRef();

  useEffect(() => {
    if (dealRef.current)
      dealRef.current.setAttribute('tl:dimension', dealDimension);

    TMON.oApp.oZzim = new Zzim();
    return () => TMON.oApp.oZzim.clearEvent();
  }, [dealDimension]);

  return (
    <Fragment>
      <div className="deal_like">
        <div
          className="button_heart_wrap only"
          data-zzim="deal"
          data-use-count="true"
          data-tlarea="BWCO"
          data-tlord="1"
          ref={dealRef}
        />
      </div>
      <PartnerDealLike />
    </Fragment>
  );
}

const PartnerDealLike = () => {
  // 앱인 경우 5.3.7 버전 이상부터 판매자찜하기 제공
  /* eslint-disable no-underscore-dangle */
  if (
    TMON.view_mode === 'app' &&
    (TMON.app.checkVersion('5.3.7') === null ||
      TMON.app.checkVersion('5.3.7') < 0)
  ) {
    return null;
  }

  const mainDealSrl = `main_deal_srl:${TMON.htStaticData.sDealNo}`;
  const partnerSrl = `partner_srl:${TMON.htStaticData.htDealInfo.partnerNo}`;
  const partnerDimension = `${mainDealSrl}__${partnerSrl}`;
  const htPartnerPostInfo = TMON.oApp.oApi.getApiInfo('postDibsInfo', {
    dibsType: 'PARTNER',
  });
  const sPartnerPostUrl = `${htPartnerPostInfo.callParam.url}?${$.param(
    htPartnerPostInfo.callParam.params
  )}`;
  const htPartnerPostData = JSON.stringify(htPartnerPostInfo.callParam.data);
  const partnerRef = useRef();

  useEffect(() => {
    if (partnerRef.current)
      partnerRef.current.setAttribute('tl:dimension', partnerDimension);
  }, [partnerDimension]);

  return (
    <div className="deal_like">
      <div
        className="button_heart_wrap only"
        data-zzim="partner"
        data-use-count="true"
        data-tlarea="DDPNH"
        data-tlord="1"
        data-post-url={sPartnerPostUrl}
        data-post-data={htPartnerPostData}
        ref={partnerRef}
      />
    </div>
  );
};

export default DealLike;
